import React from 'react';
import LocalSeoPage from './LocalSeoPage';

const DepannageSegny: React.FC = () => (
  <LocalSeoPage
    city="Segny"
    slug="depannage-informatique-segny"
    metaTitle="Dépannage Informatique Segny | Technicien PC Pays de Gex"
    metaDescription="Technicien informatique à Segny. PC lent, virus, WiFi, Windows. Intervention rapide à domicile ou à distance. Diagnostic gratuit."
    intro="Votre ordinateur vous cause des soucis à Segny ? Notre technicien intervient rapidement à domicile ou à distance. PC lent, virus, problème WiFi ou Windows bloqué — on trouve la solution. Diagnostic gratuit, devis clair, zéro surprise."
    postalCode="01170"
    nearbyTowns={[
      { name: 'Gex', link: '/depannage-informatique-gex' },
      { name: 'Cessy', link: '/depannage-informatique-cessy' },
      { name: 'Ornex', link: '/depannage-informatique-ornex' },
      { name: 'Divonne-les-Bains', link: '/depannage-informatique-divonne-les-bains' },
      { name: 'Saint-Genis-Pouilly', link: '/depannage-informatique-saint-genis-pouilly' },
    ]}
    internalLinks={[
      { label: 'Dépannage informatique à Gex', href: '/depannage-informatique-gex' },
      { label: 'Dépannage informatique à Cessy', href: '/depannage-informatique-cessy' },
      { label: 'Dépannage informatique à Ornex', href: '/depannage-informatique-ornex' },
      { label: 'Dépannage informatique à Divonne-les-Bains', href: '/depannage-informatique-divonne-les-bains' },
      { label: 'Dépannage informatique dans le Genevois', href: '/depannage-informatique-genevois' },
    ]}
  />
);

export default DepannageSegny;
